module.exports = "/_next/static/images/chisinau-4f9384fafdb4c9ad1635353ae3e6550c.jpg.webp";